import { render, staticRenderFns } from "./LobbyFooter.vue?vue&type=template&id=57e6eafe&scoped=true&"
import script from "./LobbyFooter.vue?vue&type=script&lang=js&"
export * from "./LobbyFooter.vue?vue&type=script&lang=js&"
import style0 from "./LobbyFooter.vue?vue&type=style&index=0&id=57e6eafe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e6eafe",
  null
  
)

export default component.exports